import { bindActionCreators, PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

declare global {
  type fulfillListValType = {
    filterList?: any;
    applyFilterList?: any;
    fulfillSearchArray?: any[];
    sortSearchData?: string;
    sortSearchIdx?: number;
    keywordSearchData?: string;
    searchStartDate?: string;
    searchEndDate?: string;
    reExecuteData?: string;
    listTypeData?: string;
    currentPageNumber?: number;
    selectedExecuteIds?: number[];
    isAllSelected?: boolean;
  };
}
const initialState: fulfillListValType = {
  filterList: {
    fulfillFilter: {
      title: "이행 여부",
      data: [
        { type: "이행", checked: false },
        { type: "미이행", checked: false },
      ],
    },
    assessFilter: {
      title: "평가 여부",
      data: [
        { type: "평가 전", checked: false },
        { type: "평가 완료", checked: false },
      ],
    },
    typeFilter: {
      title: "매장 유형",
      data: [
        { type: "직영점", checked: false },
        { type: "대리점", checked: false },
        { type: "백화점", checked: false },
        { type: "면세점", checked: false },
        { type: "상설", checked: false },
        { type: "아울렛", checked: false },
      ],
    },
    groupChannelFilter: {
      title: "그룹채널",
      data: [],
    },
  },
  applyFilterList: {
    fulfillFilter: {
      title: "이행 여부",
      data: [
        { type: "이행", checked: false },
        { type: "미이행", checked: false },
      ],
    },
    assessFilter: {
      title: "평가 여부",
      data: [
        { type: "평가 전", checked: false },
        { type: "평가 완료", checked: false },
      ],
    },
    typeFilter: {
      title: "매장 유형",
      data: [
        { type: "직영점", checked: false },
        { type: "대리점", checked: false },
        { type: "백화점", checked: false },
        { type: "면세점", checked: false },
        { type: "상설", checked: false },
        { type: "아울렛", checked: false },
      ],
    },
    groupChannelFilter: {
      title: "그룹채널",
      data: [],
    },
  },
  fulfillSearchArray: [],
  keywordSearchData: "",
  sortSearchData: "최신순",
  sortSearchIdx: 0,
  reExecuteData: "",
  listTypeData: "list",
  currentPageNumber: 1,
  selectedExecuteIds: [],
  isAllSelected: false,
};

const fulfillListSlice = createSlice({
  name: "fulfillList",
  initialState,
  reducers: {
    // 기본데이터 세팅 - 그룹채널 필터 데이터는 유지하되 선택 상태는 초기화
    setListDataInit: (state: fulfillListValType) => ({
      ...state,
      ...{
        filterList: {
          ...initialState.filterList,
          groupChannelFilter: {
            title: "그룹채널",
            data: state.filterList?.groupChannelFilter?.data?.map((item: any) => ({
              ...item,
              checked: false
            })) || [],
          },
        },
        fulfillSearchArray: initialState.fulfillSearchArray,
        selectedExecuteIds: [],
        isAllSelected: false,
      },
    }),
    // 필터
    setListData: (state: fulfillListValType, action: PayloadAction<fulfillListValType>) => ({
      ...state,
      ...{
        filterList: action.payload.filterList ?? state.filterList,
        applyFilterList: action.payload.applyFilterList ?? state.applyFilterList,
        fulfillSearchArray: action.payload.fulfillSearchArray ?? state.fulfillSearchArray,
        keywordSearchData: action.payload.keywordSearchData ?? state.keywordSearchData,
        sortSearchData: action.payload.sortSearchData ?? state.sortSearchData,
        sortSearchIdx: action.payload.sortSearchIdx ?? state.sortSearchIdx,
        reExecuteData: action.payload.reExecuteData ?? state.reExecuteData,
        listTypeData: action.payload.listTypeData ?? state.listTypeData,
        currentPageNumber: action.payload.currentPageNumber ?? state.currentPageNumber,
      },
    }),
    deleteTypeSearch: (state: fulfillListValType, action: PayloadAction<any>) => {
      state.fulfillSearchArray = state.fulfillSearchArray?.filter((type) => type !== action.payload);
      // 그룹채널 필터 삭제 처리
      if (state.filterList?.groupChannelFilter) {
        state.filterList.groupChannelFilter.data = state.filterList.groupChannelFilter.data.map((item: any) => 
          item.type === action.payload ? { ...item, checked: false } : item
        );
      }
      if (state.applyFilterList?.groupChannelFilter) {
        state.applyFilterList.groupChannelFilter.data = state.applyFilterList.groupChannelFilter.data.map((item: any) => 
          item.type === action.payload ? { ...item, checked: false } : item
        );
      }
    },
    // 홈에서 링크 이동시
    setFilterFromStateList: (state, action: PayloadAction<any>) => {
      if (action.payload.key === "미이행") {
        state.filterList.fulfillFilter.data = action.payload.data;
        state.applyFilterList.fulfillFilter.data = action.payload.data;
        state.filterList.assessFilter.data = [
          { type: "평가 전", checked: false },
          { type: "평가 완료", checked: false },
        ];
        state.applyFilterList.assessFilter.data = [
          { type: "평가 전", checked: false },
          { type: "평가 완료", checked: false },
        ];
      } else if (action.payload.key === "평가 전" || action.payload.key === "평가 완료") {
        state.filterList.fulfillFilter.data = [
          { type: "이행", checked: true },
          { type: "미이행", checked: false },
        ];
        state.applyFilterList.fulfillFilter.data = [
          { type: "이행", checked: true },
          { type: "미이행", checked: false },
        ];
        state.filterList.assessFilter.data = action.payload.data;
        state.applyFilterList.assessFilter.data = action.payload.data;
      } else if (action.payload.key === "전체") {
        state.filterList.fulfillFilter.data = action.payload.data1;
        state.filterList.assessFilter.data = action.payload.data2;
        state.applyFilterList.fulfillFilter.data = action.payload.data1;
        state.applyFilterList.assessFilter.data = action.payload.data2;
      } else {
        // 매장유형별 선택일 경우
        state.filterList.typeFilter.data = action.payload.data;
        state.applyFilterList.typeFilter.data = action.payload.data;
      }
    },
    // 매장 선택 관련 액션
    toggleExecuteSelect: (state: fulfillListValType, action: PayloadAction<number>) => {
      const executeId = action.payload;
      if (!state.selectedExecuteIds) {
        state.selectedExecuteIds = [];
      }
      const index = state.selectedExecuteIds.indexOf(executeId);
      if (index > -1) {
        state.selectedExecuteIds.splice(index, 1);
      } else {
        state.selectedExecuteIds.push(executeId);
      }
      state.isAllSelected = false;
    },
    setAllExecutesSelected: (state: fulfillListValType, action: PayloadAction<number[]>) => {
      state.selectedExecuteIds = action.payload;
      state.isAllSelected = true;
    },
    clearExecuteSelection: (state: fulfillListValType) => {
      state.selectedExecuteIds = [];
      state.isAllSelected = false;
    },
    setSelectedExecuteIds: (state: fulfillListValType, action: PayloadAction<number[]>) => {
      state.selectedExecuteIds = action.payload;
    },
  },
});

export const {
  setListDataInit,
  setListData,
  deleteTypeSearch,
  setFilterFromStateList,
  toggleExecuteSelect,
  setAllExecutesSelected,
  clearExecuteSelection,
  setSelectedExecuteIds
} = fulfillListSlice.actions;

export default fulfillListSlice.reducer;
